import { InjectionToken } from '@angular/core';
export const AppEnvironment = new InjectionToken('IAppEnvironmentToken');
